package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.positionInWindow
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.todayIn
import materialextension.composeapp.generated.resources.Res
import materialextension.composeapp.generated.resources.right_arrow
import org.jetbrains.compose.resources.painterResource
import team.platforma.materialextension.moc_data.MocCity
import team.platforma.materialextension.moc_data.MokOrganizations
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.fab.AppFab
//import team.platforma.multiplatform_material_extension.keyboard.rememberKeyboardHeight
import team.platforma.multiplatform_material_extension.ui.buttons.ExpandStrategy
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraTextButton
import team.platforma.multiplatform_material_extension.ui.buttons.IconGravity
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonText
import team.platforma.multiplatform_material_extension.ui.check_box.ExtraCheckBox
import team.platforma.multiplatform_material_extension.ui.core.InputFieldProperties
import team.platforma.multiplatform_material_extension.ui.date.DateField
import team.platforma.multiplatform_material_extension.ui.date.DateFieldPeriod
import team.platforma.multiplatform_material_extension.ui.drop_down.DropdownField
import team.platforma.multiplatform_material_extension.ui.drop_down.SearchField
import team.platforma.multiplatform_material_extension.ui.drop_down.model.ListItem
import team.platforma.multiplatform_material_extension.ui.email.EmailField
import team.platforma.multiplatform_material_extension.ui.full_name.FullNameField
import team.platforma.multiplatform_material_extension.ui.full_name.Type
import team.platforma.multiplatform_material_extension.ui.password.PasswordField
import team.platforma.multiplatform_material_extension.ui.phone.PhoneField
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.isChanged
import team.platforma.multiplatform_material_extension.util.forms.isValid
import team.platforma.multiplatform_material_extension.util.forms.rememberForms
import team.platforma.multiplatform_material_extension.util.keyGrabber

@Composable
fun PersonalDataPhoneTestSample() {

    var userName by remember { mutableStateOf("") }

    var userSurname by remember { mutableStateOf("") }

    var userPatronymic by remember { mutableStateOf("") }

//    var outlineStyle by remember { mutableStateOf(true) }
//
//    var inputResult by remember { mutableStateOf("") }
//
//    val imeBottom = with(LocalDensity.current) { WindowInsets.ime.getBottom(this).toDp() }

//    val keyboardHeight by rememberKeyboardHeight()


//    trackWebKeyboardHeight { keyboardHeight ->
//        webKeyboardHeight = keyboardHeight
//    }

//    KeyboardObserver.startObserving {
//        keyboardHeight = it
//    }


    val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
    var userBDate by remember { mutableStateOf<LocalDate?>(null) }
    var yearsOld by remember { mutableStateOf(false) }

    var lastItemPosition by remember { mutableStateOf(0f) }
    var fabPosition by remember { mutableStateOf(0f) }

    var calendarRange by remember {
        mutableStateOf(
            CalendarRange(
                min = currentDate.minus(DatePeriod(years = 18)),
                max = currentDate.minus(DatePeriod(years = 101))
            )
        )
    }

    var searchRegion by remember { mutableStateOf(emptyList<ListItem>()) }
    var searchCity by remember { mutableStateOf(emptyList<ListItem>()) }
    var searchOrganization by remember { mutableStateOf(emptyList<ListItem>()) }

    var periodStartDate by remember { mutableStateOf<LocalDate?>(null) }
    var periodEndDate by remember { mutableStateOf<LocalDate?>(null) }

    var region by remember {
        mutableStateOf<ListItem?>(
//            AutocompleteItem(
//                id = 1,
//                title = "Москва"
//            )
            null
        )
    }
    var city by remember {
        mutableStateOf<ListItem?>(
//            AutocompleteItem(
//                id = 102,
//                title = "Зеленоград",
//                parent = AutocompleteItem(id = 1, title = "Москва")
//            )
            null
        )
    }

//    var isDialogShow by remember { mutableStateOf(false) }

    var organization by remember {
        mutableStateOf<ListItem?>(
//            AutocompleteItem(
//                id = 1,
//                title = "Москва"
//            )
            null
        )
    }

    var gender by remember {
        mutableStateOf<ListItem?>(null)
    }


    val form by rememberForms()

    form.isChanged()
    var terms by remember { mutableStateOf(false) }

    var eMail by remember { mutableStateOf("") }
    val focusManager = LocalFocusManager.current

    Box(
        modifier = Modifier.fillMaxSize().clickable(
            indication = null,
            interactionSource = remember { MutableInteractionSource() }
        ) {
            focusManager.clearFocus()
        }
//            .then(
//                if (isDialogShow) Modifier.blur(5.dp) else Modifier
//            )
        ,
        contentAlignment = Alignment.TopCenter
    ) {


        val lazyListState = rememberLazyListState()

        LazyColumn(
            horizontalAlignment = Alignment.CenterHorizontally,
//            contentPadding = PaddingValues(vertical = 8.dp, horizontal = 16.dp),
            state = lazyListState
        ) {


            item {
                PhoneField.create(
                    phone = null,
                    onPhoneChange = { changePhone ->
                        println(changePhone)
                    },
                    formProperties = FormProperties(
                        form = form,
                        key = "phone"
                    ),
                    modifier = Modifier.fillMaxWidth()
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Номер телефона")
                        .simplePlaceholder("+7 (000) 000-00-00")
                )

                PasswordField.create(
                    password = null,
                    onPasswordChanged = { change, validate ->

                    },
                    modifier = Modifier.fillMaxWidth(),
                    formProperties = FormProperties(
                        form = form,
                        key = "password"
                    )

                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Пароль")
                )

                FullNameField.create(
                    modifier = Modifier.fillMaxWidth(),
                    value = userSurname,
                    onValueChange = {
                        userSurname = it
                    },
                    type = Type.Surname,
                    formProperties = FormProperties(
                        form = form,
                        key = "user_surname"
                    )
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    )
                        .simpleLabel("Фамилия")
                )

                FullNameField.create(
                    modifier = Modifier.fillMaxWidth(),
                    value = userName,
                    onValueChange = {
                        userName = it
                    },
                    type = Type.Name,
                    formProperties = FormProperties(
                        form = form,
                        key = "user_name"
                    )
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Имя")
                )

                FullNameField.create(
                    modifier = Modifier.fillMaxWidth(),
                    value = userPatronymic,
                    onValueChange = {
                        userPatronymic = it
                    },
                    type = Type.Patronymic,
                    required = false,
                    formProperties = FormProperties(
                        form = form,
                        key = "user_patronymic"
                    )
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Отчество")
                )

                DropdownField.create(
                    modifier = Modifier.fillMaxWidth(),
                    list = listOf(
                        ListItem(id = 0, title = "Мужской"),
                        ListItem(id = 1, title = "Женский"),
                        ListItem(id = 0, title = "Мужской"),
                        ListItem(id = 1, title = "Женский"),
                        ListItem(id = 0, title = "Мужской"),
                        ListItem(id = 1, title = "Женский"),
                        ListItem(id = 0, title = "Мужской"),
                        ListItem(id = 1, title = "Женский"),
                        ListItem(id = 0, title = "Мужской"),
                        ListItem(id = 1, title = "Женский"),
                        ListItem(id = 0, title = "Мужской"),
                        ListItem(id = 1, title = "Женский"),
                        ListItem(id = 0, title = "Мужской"),
                        ListItem(id = 1, title = "Женский")
                    ),
                    onItemSet = { selectedGender ->
                        gender = selectedGender
                    },
                    initializeItem = gender,
                    required = true,
                    onClear = {
                        gender = null
                    },
                    formProperties = FormProperties(
                        form = form,
                        key = "gender"
                    )
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Пол")
                )

                DateField.create(
                    modifier = Modifier.fillMaxWidth(),
                    localDate = userBDate,
                    onLocalDateChange = {
                        userBDate = it
                    },
                    calendarRange = calendarRange,
                    required = true,
                    formProperties = FormProperties(
                        form = form,
                        key = "d_date"
                    ),
//                    dialogViewState = { boolean ->
//                        isDialogShow = boolean
//                    }
                ).Outline(
                    properties =
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Дата рождения")
                )

                DateFieldPeriod.create(
                    modifier = Modifier.fillMaxWidth(),
                    startDate = periodStartDate,
                    endDate = periodEndDate,
                    calendarRange = null,
                    required = true,
                    formProperties = FormProperties(
                        form = form,
                        key = "period_date"
                    ),
                    onPeriodDateChange = { startDate, endDate ->
                        periodStartDate = startDate
                        periodEndDate = endDate
                    }
                ).Outline(
                    properties =
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Период дат")
                        .simplePlaceholder("дд.мм.гггг - дд.мм.гггг")
                )


                searchOrganization = MokOrganizations().searchOrganization("")

                val scope = rememberCoroutineScope()
                SearchField.create(
                    modifier = Modifier.fillMaxWidth(),
                    itemsList = searchOrganization,
                    searchQuery = { query ->
                        scope.launch {
                            delay(700)
                            searchOrganization = MokOrganizations().searchOrganization(query)
                        }
                    },
                    initializeItem = organization,
                    onSelectItem = { selectedOrganization ->
                        organization = selectedOrganization
                    },
                    required = false,
                    formProperties = FormProperties(
                        form = form,
                        key = "organization"
                    ),
                    onClear = {
                        organization = null
                    },
                    searchDialogTitle = "Выберите организацию из списка"
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Организация")
                )


                searchRegion = MocCity().searchRegion("")

//                val scope = rememberCoroutineScope()
                SearchField.create(
                    modifier = Modifier.fillMaxWidth(),
                    itemsList = searchRegion,
                    searchQuery = {
                        scope.launch {
                            delay(700)
                            searchRegion = MocCity().searchRegion(it)
                        }
                    },
                    initializeItem = region,
                    onSelectItem = { selectedRegion ->
                        region = selectedRegion
                        searchCity = MocCity().searchCity(selectedRegion.id, "")
                    },
                    required = true,
                    formProperties = FormProperties(
                        form = form,
                        key = "region"
                    ),
                    searchDialogTitle = "Выберите регион из списка"
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("Регион")
                )


                searchCity = MocCity().searchCity(regionId = null, "")

//                val scope = rememberCoroutineScope()
                SearchField.create(
                    modifier = Modifier.fillMaxWidth(),
                    itemsList = searchCity,
                    parent = region,
                    searchQuery = {
                        scope.launch {
                            delay(700)
                            searchCity = MocCity().searchCity(regionId = region?.id, it)
                        }
                    },
                    onSelectItem = { selectedCity ->
                        selectedCity.parent?.let { parent ->
                            region = parent
                        }
                        city = selectedCity
                    },
                    initializeItem = city,
                    required = true,
                    formProperties = FormProperties(
                        form = form,
                        key = "city"
                    ),
                    searchDialogTitle = "Выберите город из списка"
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                            .onGloballyPositioned { layoutCoordinates ->
                                lastItemPosition =
                                    layoutCoordinates.positionInWindow().y + layoutCoordinates.size.height
                            }
                    ).simpleLabel("Город")
                )

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Start
                ) {
                    ExtraCheckBox(
                        checked = terms,
                        onCheckedChange = {
                            terms = it
                        },
                        formProperties = FormProperties(
                            form = form,
                            key = "terms"
                        )
                    )
                    ExtraTextButton(
                        onClick = {},
                        buttonText = ButtonText(
                            text = "Ознакомится с условиями"
                        ),
                        modifier = Modifier.weight(1f)
                    )

                }

                EmailField.create(
                    email = eMail,
                    onEmailChange = { change ->
                        eMail = change
                    },
                    modifier = Modifier.fillMaxWidth(),
                    formProperties = FormProperties(
                        form = form,
                        key = "e-mail"
                    ),
                    // required = false
                ).Outline(
                    InputFieldProperties(
                        modifier = Modifier.fillMaxWidth()
                    ).simpleLabel("E-mail")
                        .simplePlaceholder("Введите e-mail (не обязательно)")
                )
            }


//            item {
//                Spacer(
//                    modifier = Modifier.height(80.dp)
//                )
//            }

//            item {
//                if (imeBottom > 0.dp) {
//                    Box(modifier = Modifier.height(imeBottom))
//                }
//            }
//            item {
//                if (keyboardHeight > 0.dp) {
//                    Box(modifier = Modifier.height(keyboardHeight))
//                }
//            }


        }

        AppFab(
            expand = fabPosition > lastItemPosition,
            modifier = Modifier.align(Alignment.BottomEnd)
                .onGloballyPositioned { layoutCoordinates ->
                    fabPosition = layoutCoordinates.positionInWindow().y
                },
            expandStrategy = ExpandStrategy.MaxWidth,
            iconGravity = IconGravity.End,
            hide = userSurname.isEmpty(),
            text = {
                Text(
                    text = "Продожить"
                )
            },
            icon = {
                Icon(
                    painter = painterResource(Res.drawable.right_arrow),
                    contentDescription = null
                )
            },
            enabled = form.isValid(),
            onClick = {
                println("fab clicked!")
            }
        )


    }
}
